/**
 * This keeps track of latest subOrgId. This mixin can be injected in a component that exposes *subOrgId*.
 */
export default {
  mounted() {
    this.subOrgId && this.$store.dispatch('orgSelect/select', { subOrgId: this.subOrgId })
  },
  watch: {
    subOrgId(subOrgId) {
      subOrgId && this.$store.dispatch('orgSelect/select', { subOrgId })
    }
  }
}
